<template>
  <header class="desktop">
    <MediaRail />
    <SearchRailEnchanced />
    <NavigationRail />
  </header>
</template>

<script setup>
/* v8 ignore file -- @preserve */
import MediaRail from '../header-responsive/MediaRail.bcom';
import NavigationRail from './NavigationRail.common';
import SearchRailEnchanced from './SearchRailEnchanced.common';
</script>
